<template>
  <div>

    <v-row>
      <v-col cols="12" sm="4">
        <v-select
          :items="reports"
          v-model="report"
          item-text="name"
          item-value="ref"
          @change="change()"
          solo dense hide-details></v-select>
      </v-col>
    </v-row>

    <component :is="component"/>

  </div>
</template>

<script>
import ReportGeral from './ReportGeral.vue';
import ReportCancelamento from './ReportCancelamento.vue';
import ReportInstalacao from './ReportInstalacao.vue';

export default {
  components: { ReportGeral, ReportCancelamento, ReportInstalacao },
  data: () => ({
    report: "geral",
    reports: [
      {ref: "geral", name: "Visão geral", component: "ReportGeral"},
      {ref: "instalacao", name: "Instalações por mês", component: "ReportInstalacao"},
      {ref: "cancelamento", name: "Cancelamentos por mês", component: "ReportCancelamento"}
    ]
  }),
  created: function() {
    var query = this.$route.query.r;
    if(query && this.find(query)){
      this.report = query;
    }
  },
  computed: {
    component: function() {
      var found = this.find(this.report);
      return found ? found.component : "ReportGeral";
    }
  },
  methods: {
    find: function(ref) {
      return this.reports.filter(function(item){ return item.ref == ref; })[0];
    },
    change: function() {
      if(this.$route.query.r != this.report){
        this.$router.replace({path: "/internet/report", query: {r: this.report}});
      }
    }
  }
};
</script>
